import { FormattedMessage } from 'react-intl';

import { BrandXXS } from '@sorare/core/src/atoms/typography';
import { CornerBadge } from '@sorare/core/src/components/CornerBadge';

export const InLineupCornerBadge = () => {
  return (
    <CornerBadge color="var(--c-white)">
      <BrandXXS>
        <FormattedMessage id="CartItem.inLineup" defaultMessage="In Lineup" />
      </BrandXXS>
    </CornerBadge>
  );
};
